import {
  ASYNC_ONDE_RECEBER,
  ASYNC_ONDE_USAR,
  ASYNC_RECEBER_ADESIVO,
  ASYNC_SALVAR_DADOS_USUARIO,
  ASYNC_SALVAR_DESCONTO,
  ASYNC_SALVAR_LISTA_PRODUTOS,
  ASYNC_SALVAR_TIPO_VEICULO,
  ASYNC_SALVAR_VALOR_RECARGA,
  ASYNC_TIPO_PAGAMENTO,
  ASYNC_TOTAL_PRODUTOS,
  ASYNC_SALVAR_CODIGO_PROMOCIONAL,
} from '../../actions/asyncActions';

const getInitialState = () => {
  return {
    data: null,
  };
};

const asyncPedido = (state = getInitialState(), action) => {
  switch (action.type) {
    case ASYNC_SALVAR_DADOS_USUARIO:
    case ASYNC_SALVAR_LISTA_PRODUTOS:
    case ASYNC_SALVAR_TIPO_VEICULO:
    case ASYNC_SALVAR_CODIGO_PROMOCIONAL:
    case ASYNC_ONDE_USAR:
    case ASYNC_RECEBER_ADESIVO:
    case ASYNC_ONDE_RECEBER:
    case ASYNC_TIPO_PAGAMENTO:
    case ASYNC_SALVAR_VALOR_RECARGA:
    case ASYNC_SALVAR_DESCONTO:
    case ASYNC_TOTAL_PRODUTOS:
      return { ...state, data: action.data };
    default:
      return state;
  }
};

export default asyncPedido;
